var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4323_33852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4323_33852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4323_33852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.333 12.5417C23.333 10.911 23.333 9.80388 23.0665 9.16069C22.7114 8.3031 22.03 7.62173 21.1725 7.2665C20.5292 7.00008 19.7138 7.00008 18.083 7.00008C16.883 7.00008 15.6829 7.00008 14.4829 7.00008C14.2862 7.00008 14.1879 7.00008 14.0931 6.99494C13.2969 6.95172 12.5392 6.63791 11.9456 6.10545C11.8749 6.04206 11.8054 5.97252 11.6663 5.83341C11.5272 5.69431 11.4577 5.62477 11.387 5.56138C10.7935 5.02892 10.0358 4.71511 9.2396 4.67189C9.14484 4.66675 9.04647 4.66675 8.84976 4.66675C8.54418 4.66675 8.23859 4.66675 7.93301 4.66675C5.97282 4.66675 4.99273 4.66675 4.24404 5.04822C3.58547 5.38378 3.05004 5.91921 2.71448 6.57778C2.33301 7.32647 2.33301 8.30656 2.33301 10.2667C2.33301 12.7556 2.33301 15.2445 2.33301 17.7334C2.33301 19.6936 2.33301 20.6736 2.71448 21.4224C3.05004 22.081 3.58547 22.6164 4.24404 22.9519C4.99273 23.3334 5.97282 23.3334 7.93301 23.3334C9.56634 23.3334 11.1997 23.3334 12.833 23.3334",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39417 14C7.39417 14 4.31745 16.7591 3.88121 18.53C3.44496 20.301 3.49973 20.9479 3.88121 21.6194C4.21676 22.2101 4.75219 22.6902 5.41076 22.9912C6.15945 23.3333 7.13954 23.3333 9.09973 23.3333C12.3664 23.3333 15.6331 23.3333 18.8997 23.3333C20.86 23.3333 21.0922 23.3333 21.841 22.9912C22.4995 22.6902 23.0349 22.2101 23.3705 21.6194C23.5677 21.2723 23.7719 20.1783 24.4413 18.53C25.0669 16.9898 26.1407 14.9116 26.8331 14H7.39417Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4323_33852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.5d0fe55c186221992f520e6f689cd5da.svg";
export { ForwardRef as ReactComponent };